export default __webpack_public_path__ + "static/media/VICKY DODANI.7407d0d6.png";